// UI label translations (EN / Gujarati). Content data (districts, bearers, GRs)
// comes bilingual from the backend. Add new keys here as later phases grow.

export const translations = {
  en: {
    assocShort: "GMOAA",
    assocName: "Medical Officers (Ayurved) Association, Gujarat State",
    assocTagline: "In service of Government Ayurved Medical Officers across Gujarat since 1986",
    address: "GMOAA Bhavan, Sector 11, Gandhinagar, Gujarat — 382011",
    helpLine: "Help",
    langLabel: "ગુજરાતી",

    // nav
    navHome: "Home",
    navAbout: "About",
    navBearers: "Office Bearers",
    navConstitution: "Constitution",
    navDistricts: "Districts",
    navGr: "GR & Notices",
    navGapl: "GAPL",
    navAdvertise: "Advertise",
    navContact: "Contact",
    memberLogin: "Member Login",
    myDashboard: "My Dashboard",
    raiseIssue: "Raise an Issue",

    // hero
    heroTitle: "Medical Officers (Ayurved) Association, Gujarat State",
    heroSubtitle: "A united voice for Government Ayurved Medical Officers serving all 33 districts of Gujarat — advancing welfare, education and professional dignity.",
    knowMore: "Know more",

    // gapl card
    gaplCountdownTitle: "GAPL Season 5 begins in",
    days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds",
    viewGapl: "View GAPL hub",

    // sections
    ourImpact: "Our Impact",
    importantLabel: "Important",
    liveCounters: "Live",
    visitorsToday: "Visitors today",
    visitorsTotal: "Total visitors",
    membersOnline: "Members online",
    followUs: "Follow us",
    whatsappChat: "WhatsApp Chat",
    grTitle: "Government GRs & Notifications",
    tabGr: "Government Resolutions",
    tabNotices: "Notices & Circulars",
    viewAll: "View all",
    upcoming: "Upcoming",
    bearersTitle: "Office Bearers",
    bearersSubtitle: "The elected team leading the association",
    viewAllBearers: "View full committee",
    districtsTitle: "Districts",
    districtsSubtitle: "Representation across all 33 districts of Gujarat",
    moreDistricts: "more districts",
    viewAllDistricts: "View all districts",
    sponsorsTitle: "Our Sponsors & Partners",
    advertiseCta: "Advertise with us",
    advertiseCtaSub: "Reach thousands of Ayurved medical officers across Gujarat",

    // ad
    advertisement: "Advertisement",

    // footer
    quickLinks: "Quick Links",
    legal: "Legal",
    contactUs: "Contact Us",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    refund: "Refund Policy",
    adPolicy: "Advertising Policy",
    rights: "All rights reserved.",
    sampleBadge: "Sample data",
    laterPhase: "Coming in a later phase",

    // district detail
    coordinator: "District Coordinator",
    members: "Members",
    backToDistricts: "Back to all districts",
    districtMembersNote: "The member roster for this district will appear here once the association roster is imported in a later phase.",

    // gr page
    searchGr: "Search by title or number...",
    filterAll: "All",
    filterAyush: "AYUSH Dept.",
    filterHealth: "Health Ministry",
    filterGmoaa: "GMOAA Circulars",
    download: "Download",
    noResults: "No matching documents found.",
    checkOriginal: "Always check the original document from the issuing authority. PDFs here are for reference.",

    // gapl page
    pointsTable: "Points Table",
    fixtures: "Fixtures",
    teams: "Teams",
    team: "Team", played: "P", won: "W", lost: "L", points: "Pts",
    liveScoringNote: "Live ball-by-ball scoring and match centre arrive in a later phase.",

    // advertise page
    advertiseTitle: "Advertise with GMOAA",
    advertiseIntro: "Place your brand in front of a trusted community of government Ayurved medical officers across Gujarat. Choose from premium slots on our high-traffic pages.",
    adSlots: "Ad Slots",
    rateCard: "Rate Card",
    slotName: "Slot", size: "Placement", rate: "Monthly Rate",
    enquire: "Enquire to advertise",
    matchSponsors: "Match Centre Sponsors",
    onRequest: "On request",

    // contact
    contactTitle: "Contact / Raise an Issue",
    contactIntro: "Members and visitors can reach the association or raise a concern using this form. Our team reviews every submission.",
    formName: "Full name",
    formEmail: "Email (optional)",
    formMobile: "Mobile (optional)",
    formDistrict: "District (optional)",
    formCategory: "Category",
    formSubject: "Subject",
    formMessage: "Message",
    catGeneral: "General enquiry",
    catMembership: "Membership",
    catGr: "GR / Notification",
    catPayment: "Payment / Dues",
    catGapl: "GAPL",
    catGrievance: "Grievance",
    submit: "Submit",
    submitting: "Submitting...",
    thankYou: "Thank you! Your message has been received.",
    required: "Please fill the required fields.",

    // member login modal
    memberPortalTitle: "Member Portal",
    memberPortalBody: "Secure member login with mobile OTP, membership verification and online dues payment arrives in a later phase. For now, please use Contact to reach the association.",
    gotIt: "Got it",

    // about
    aboutTitle: "About GMOAA",
    constitutionTitle: "Constitution",
    constitutionBody: "The official constitution document of the association. A placeholder PDF is shown below and will be replaced with the registered constitution.",
    viewPdf: "View document",

    // gapl extra
    squads: "Squads",
    captain: "Captain",
    players: "Players",
    venue: "Venue",
    lastSeasonSquads: "Last Season — Squads & Schedule",
    schedule: "Schedule",
    adminLogin: "Admin",
  },
  gu: {
    assocShort: "GMOAA",
    assocName: "મેડિકલ ઓફિસર્સ (આયુર્વેદ) એસોસિએશન, ગુજરાત રાજ્ય",
    assocTagline: "૧૯૮૬થી ગુજરાતભરના સરકારી આયુર્વેદ મેડિકલ ઓફિસરની સેવામાં",
    address: "GMOAA ભવન, સેક્ટર ૧૧, ગાંધીનગર, ગુજરાત — ૩૮૨૦૧૧",
    helpLine: "સહાય",
    langLabel: "English",

    navHome: "મુખ્ય પૃષ્ઠ",
    navAbout: "અમારા વિશે",
    navBearers: "હોદ્દેદારો",
    navConstitution: "બંધારણ",
    navDistricts: "જિલ્લાઓ",
    navGr: "GR અને સૂચનાઓ",
    navGapl: "GAPL",
    navAdvertise: "જાહેરાત",
    navContact: "સંપર્ક",
    memberLogin: "સભ્ય લોગિન",
    myDashboard: "મારું ડેશબોર્ડ",
    raiseIssue: "સમસ્યા નોંધાવો",

    heroTitle: "મેડિકલ ઓફિસર્સ (આયુર્વેદ) એસોસિએશન, ગુજરાત રાજ્ય",
    heroSubtitle: "ગુજરાતના તમામ ૩૩ જિલ્લાઓમાં સેવા આપતા સરકારી આયુર્વેદ મેડિકલ ઓફિસરોનો એકજૂટ અવાજ — કલ્યાણ, શિક્ષણ અને વ્યાવસાયિક ગૌરવને આગળ વધારતો.",
    knowMore: "વધુ જાણો",

    gaplCountdownTitle: "GAPL સીઝન ૫ શરૂ થવામાં",
    days: "દિવસ", hours: "કલાક", minutes: "મિનિટ", seconds: "સેકન્ડ",
    viewGapl: "GAPL હબ જુઓ",

    ourImpact: "અમારો પ્રભાવ",
    importantLabel: "મહત્વપૂર્ણ",
    liveCounters: "લાઇવ",
    visitorsToday: "આજના મુલાકાતીઓ",
    visitorsTotal: "કુલ મુલાકાતીઓ",
    membersOnline: "ઓનલાઇન સભ્યો",
    followUs: "અમને અનુસરો",
    whatsappChat: "વોટ્સએપ ચેટ",
    grTitle: "સરકારી GR અને સૂચનાઓ",
    tabGr: "સરકારી ઠરાવો",
    tabNotices: "સૂચનાઓ અને પરિપત્રો",
    viewAll: "બધું જુઓ",
    upcoming: "આગામી",
    bearersTitle: "હોદ્દેદારો",
    bearersSubtitle: "એસોસિએશનનું નેતૃત્વ કરતી ચૂંટાયેલી ટીમ",
    viewAllBearers: "સંપૂર્ણ સમિતિ જુઓ",
    districtsTitle: "જિલ્લાઓ",
    districtsSubtitle: "ગુજરાતના તમામ ૩૩ જિલ્લાઓમાં પ્રતિનિધિત્વ",
    moreDistricts: "વધુ જિલ્લાઓ",
    viewAllDistricts: "બધા જિલ્લાઓ જુઓ",
    sponsorsTitle: "અમારા સ્પોન્સર્સ અને ભાગીદારો",
    advertiseCta: "અમારી સાથે જાહેરાત કરો",
    advertiseCtaSub: "ગુજરાતભરના હજારો આયુર્વેદ મેડિકલ ઓફિસરો સુધી પહોંચો",

    advertisement: "જાહેરાત",

    quickLinks: "ઝડપી લિંક્સ",
    legal: "કાનૂની",
    contactUs: "સંપર્ક કરો",
    privacy: "ગોપનીયતા નીતિ",
    terms: "નિયમો અને શરતો",
    refund: "રિફંડ નીતિ",
    adPolicy: "જાહેરાત નીતિ",
    rights: "સર્વ હક્ક સુરક્ષિત.",
    sampleBadge: "નમૂના માહિતી",
    laterPhase: "આગામી તબક્કામાં આવશે",

    coordinator: "જિલ્લા સંયોજક",
    members: "સભ્યો",
    backToDistricts: "બધા જિલ્લાઓ પર પાછા",
    districtMembersNote: "આ જિલ્લાની સભ્ય યાદી આગામી તબક્કામાં એસોસિએશનની યાદી આયાત થયા પછી અહીં દેખાશે.",

    searchGr: "શીર્ષક અથવા નંબર દ્વારા શોધો...",
    filterAll: "બધા",
    filterAyush: "આયુષ વિભાગ",
    filterHealth: "આરોગ્ય મંત્રાલય",
    filterGmoaa: "GMOAA પરિપત્રો",
    download: "ડાઉનલોડ",
    noResults: "કોઈ મેળ ખાતા દસ્તાવેજો મળ્યા નથી.",
    checkOriginal: "હંમેશા જારી કરનાર સત્તાધિકારી પાસેથી મૂળ દસ્તાવેજ ચકાસો. અહીંની PDF સંદર્ભ માટે છે.",

    pointsTable: "પોઇન્ટ ટેબલ",
    fixtures: "ફિક્સચર્સ",
    teams: "ટીમો",
    team: "ટીમ", played: "રમ્યા", won: "જીત", lost: "હાર", points: "ગુણ",
    liveScoringNote: "લાઇવ બોલ-બાય-બોલ સ્કોરિંગ અને મેચ સેન્ટર આગામી તબક્કામાં આવશે.",

    advertiseTitle: "GMOAA સાથે જાહેરાત કરો",
    advertiseIntro: "ગુજરાતભરના સરકારી આયુર્વેદ મેડિકલ ઓફિસરોના વિશ્વસનીય સમુદાય સમક્ષ તમારી બ્રાન્ડ રજૂ કરો. અમારા ઉચ્ચ-ટ્રાફિક પૃષ્ઠો પર પ્રીમિયમ સ્લોટ પસંદ કરો.",
    adSlots: "જાહેરાત સ્લોટ્સ",
    rateCard: "રેટ કાર્ડ",
    slotName: "સ્લોટ", size: "સ્થાન", rate: "માસિક દર",
    enquire: "જાહેરાત માટે પૂછપરછ કરો",
    matchSponsors: "મેચ સેન્ટર સ્પોન્સર્સ",
    onRequest: "વિનંતી પર",

    contactTitle: "સંપર્ક / સમસ્યા નોંધાવો",
    contactIntro: "સભ્યો અને મુલાકાતીઓ આ ફોર્મ દ્વારા એસોસિએશનનો સંપર્ક કરી શકે છે અથવા સમસ્યા નોંધાવી શકે છે. અમારી ટીમ દરેક સબમિશનની સમીક્ષા કરે છે.",
    formName: "પૂરું નામ",
    formEmail: "ઈમેલ (વૈકલ્પિક)",
    formMobile: "મોબાઇલ (વૈકલ્પિક)",
    formDistrict: "જિલ્લો (વૈકલ્પિક)",
    formCategory: "શ્રેણી",
    formSubject: "વિષય",
    formMessage: "સંદેશ",
    catGeneral: "સામાન્ય પૂછપરછ",
    catMembership: "સભ્યપદ",
    catGr: "GR / સૂચના",
    catPayment: "ચુકવણી / લેણાં",
    catGapl: "GAPL",
    catGrievance: "ફરિયાદ",
    submit: "સબમિટ કરો",
    submitting: "સબમિટ થઈ રહ્યું છે...",
    thankYou: "આભાર! તમારો સંદેશ મળી ગયો છે.",
    required: "કૃપા કરીને જરૂરી ફીલ્ડ ભરો.",

    memberPortalTitle: "સભ્ય પોર્ટલ",
    memberPortalBody: "મોબાઇલ OTP સાથે સુરક્ષિત સભ્ય લોગિન, સભ્યપદ ચકાસણી અને ઓનલાઇન લેણાં ચુકવણી આગામી તબક્કામાં આવશે. હાલ પૂરતું, કૃપા કરીને એસોસિએશનનો સંપર્ક કરવા સંપર્ક પૃષ્ઠનો ઉપયોગ કરો.",
    gotIt: "સમજાયું",

    aboutTitle: "GMOAA વિશે",
    constitutionTitle: "બંધારણ",
    constitutionBody: "એસોસિએશનનું સત્તાવાર બંધારણ દસ્તાવેજ. નીચે એક પ્લેસહોલ્ડર PDF બતાવવામાં આવ્યું છે જે નોંધાયેલ બંધારણ સાથે બદલવામાં આવશે.",
    viewPdf: "દસ્તાવેજ જુઓ",

    squads: "ટીમો",
    captain: "કેપ્ટન",
    players: "ખેલાડીઓ",
    venue: "સ્થળ",
    lastSeasonSquads: "ગત સીઝન — ટીમો અને સમયપત્રક",
    schedule: "સમયપત્રક",
    adminLogin: "એડમિન",
  },
};
